// helpers/pdfService.js
export const sendPdfRequest = async (url, payload) => {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`HTTP ${response.status}: ${errorText}`)
  }

  return response
}

export const downloadBlobAsFile = (blob, filename) => {
  const blobFile = new File([blob], filename, { type: "application/pdf" })
  const blobUrl = URL.createObjectURL(blobFile)
  window.open(blobUrl, "_blank")

  setTimeout(() => URL.revokeObjectURL(blobUrl), 10000)
}

export const generateFilenamePdf = async json => {
  const encoder = new TextEncoder()
  const data = encoder.encode(json)
  const hashBuffer = await crypto.subtle.digest("SHA-256", data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray
    .map(b => b.toString(16).padStart(2, "0"))
    .join("")
    .slice(0, 8)
  return `${Date.now()}_${hashHex}.pdf`
}
